import { defineAsyncComponent } from 'vue';

const INInwardDetail = defineAsyncComponent(() => import('@/views/inventory/inInward/INInwardDetail.vue'));

const INOutwardDetail = defineAsyncComponent(() => import('@/views/inventory/inOutward/INOutwardDetail.vue'));

const INTransferDetail = defineAsyncComponent(() => import('@/views/inventory/inTransfers/INTransferDetail.vue'));

const INAdjustmentDetail = defineAsyncComponent(() => import('@/views/inventory/inAdjustment/INAdjustmentDetail.vue'));

const CalcInOutwardDetail = defineAsyncComponent(() => import('@/views/inventory/calcStock/CalcInOutwardDetail.vue'));
const OutWardErrorPopup = defineAsyncComponent(() => import('@/views/inventory/common/OutWardErrorPopup.vue'));

// nhập kho từ điều chỉnh tồn kho
const INInwardFromINAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/inventory/inAdjustment/INInwardFromINAdjustmentDetail.vue')
);
// nhập kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
const INInwardFromINAdjustmentChangeAmountDetail = defineAsyncComponent(() =>
  import('@/views/inventory/inAdjustment/INInwardFromINAdjustmentChangeAmountDetail.vue')
);
// xuất kho từ điều chỉnh tồn kho
const INOutwardFromINAdjustmentDetail = defineAsyncComponent(() =>
  import('@/views/inventory/inAdjustment/INOutwardFromINAdjustmentDetail.vue')
);
// xuất kho từ điều chỉnh tồn kho (Có điều chỉnh giá trị)
const INOutwardFromINAdjustmentChangeAmountDetail = defineAsyncComponent(() =>
  import('@/views/inventory/inAdjustment/INOutwardFromINAdjustmentChangeAmountDetail.vue')
);
const ApproveVoucherINInwardTab = defineAsyncComponent(() =>
  import('@/views/inventory/inInward/ApproveVoucherINInwardTab.vue')
);

const ApproveVoucherINTransferList = defineAsyncComponent(() =>
  import('@/views/inventory/inTransfers/ApproveVoucherINTransferList.vue')
);

const ApproveVoucherINOutwardList = defineAsyncComponent(() =>
  import('@/views/inventory/inOutward/ApproveVoucherINOutwardList.vue')
);

const ApproveVoucherINAdjustmentList = defineAsyncComponent(() =>
  import('@/views/inventory/inAdjustment/ApproveVoucherINAdjustmentList.vue')
);
const ReArrangeInventoryPopup = defineAsyncComponent(() =>
  import('@/views/inventory/processInventory/ReArrangeInventoryPopup.vue')
);

export function registerInventory(app) {
  app.component('INInwardDetail', INInwardDetail);
  app.component('INTransferDetail', INTransferDetail);
  app.component('INAdjustmentDetail', INAdjustmentDetail);
  app.component('INOutwardDetail', INOutwardDetail);
  app.component('CalcInOutwardDetail', CalcInOutwardDetail);
  app.component('OutWardErrorPopup', OutWardErrorPopup);
  app.component('INInwardFromINAdjustmentDetail', INInwardFromINAdjustmentDetail);
  app.component('INInwardFromINAdjustmentChangeAmountDetail', INInwardFromINAdjustmentChangeAmountDetail);
  app.component('INOutwardFromINAdjustmentDetail', INOutwardFromINAdjustmentDetail);
  app.component('INOutwardFromINAdjustmentChangeAmountDetail', INOutwardFromINAdjustmentChangeAmountDetail);
  app.component('ApproveVoucherINInwardTab', ApproveVoucherINInwardTab);
  app.component('ApproveVoucherINTransferList', ApproveVoucherINTransferList);
  app.component('ApproveVoucherINOutwardList', ApproveVoucherINOutwardList);
  app.component('ApproveVoucherINAdjustmentList', ApproveVoucherINAdjustmentList);
  app.component('ReArrangeInventoryPopup', ReArrangeInventoryPopup);
}
